import VueRouter from 'vue-router';
import { RouterV2Enum } from '@/router/router-names';
import store from '@/store';
import { jumpToPage } from './utils';

/** 处理现金活动资格 */
export async function resolveCashActivityQualification(
  this: VueRouter,
  query: Dictionary<string>,
): Promise<void> {
  /** 获取现金活动详情 */
  await store.dispatch('verifyCredit/getCashActivityDetail');
  /** 不在圈选人群内，跳转授信现金活动无法参与结果页 */
  if (!store.state.verifyCredit.cashActivityMatch) {
    jumpToPage.call(this, {
      path: RouterV2Enum.cashActivityDisqualification,
      query,
    }, true);
  }
}
